import React from 'react'
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const slideIn = {
  visible: { opacity: 1, translateX: 0 },
  hidden: { opacity: 0, translateX: -200 },
};
const AboutContent = ({heading, grayHeading, text, boldText}) => {
    const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.3
	  });
	
  return (

    /* -------------------------------------------------------------------------- */
    /*                              CONTENT CONTAINER                             */
    /* -------------------------------------------------------------------------- */
    <motion.div
        ref={ref}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={slideIn}
        transition={{ duration: 0.8, ease: "easeIn" }}
        className='flex flex-col md:flex-row items-center md:justify-evenly p-2 md:p-3 md:py-20 gap-x-20 md:mt-0'
    >

        {/* --------------------------------- HEADING -------------------------------- */}
        <h1 className='text-3xl md:text-5xl font-popp font-semibold text-center 1.5xl:text-left  text-white px-2'>
            {heading}
            <h1 className='inline text-[#808080]'>{grayHeading}</h1>
        </h1>

        {/* -------------------------------- PARAGRAPH ------------------------------- */}
        <div className='flex flex-col gap-y-3 font-popp text-center md:text-left px-4 pt-4'>

            {/* -------------------------- GREEN BOLD TEXT ------------------------- */}
            <h3 className='text-base font-light md:text-xl text-secondary max-w-[580px] md:pb-6'>
                {boldText}
            </h3>

            {/* -------------------------------- TEXT CONTENT ------------------------------- */}
            <p className='text-base font-extralight md:text-lg max-w-[580px]  text-[#CCCCCC]'>
                {text}
            </p>
        </div>
    </motion.div>
  )
}

export default AboutContent